import { render, staticRenderFns } from "./setting-personal-account.vue?vue&type=template&id=39299e6e&"
import script from "./setting-personal-account.vue?vue&type=script&lang=js&"
export * from "./setting-personal-account.vue?vue&type=script&lang=js&"
import style0 from "./setting-personal-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports